const recycleBinItems = [
  {
    name: "data_science_portfolio_v1.html",
    deleted: "Jan 15, 2026",
    size: "2.4 MB",
    note: "Replaced with something with better art direction.",
  },
  {
    name: "kaggle_competitions/",
    deleted: "Jan 10, 2026",
    size: "128 MB",
    note: "Moved on to campaigns that people actually want to look at.",
  },
  {
    name: "matplotlib_charts_final_FINAL2.png",
    deleted: "Dec 28, 2025",
    size: "890 KB",
    note: "Beautiful data. Wrong portfolio.",
  },
  {
    name: "neural_network_diagram.ai",
    deleted: "Dec 20, 2025",
    size: "4.1 MB",
    note: "Too many nodes. Not enough narrative.",
  },
  {
    name: "resume_data_analyst.doc",
    deleted: "Nov 30, 2025",
    size: "48 KB",
    note: "Creative Director sounded more honest.",
  },
  {
    name: "stock_photo_briefcase_guy.jpg",
    deleted: "Nov 12, 2025",
    size: "1.2 MB",
    note: "Nobody believes that guy works here.",
  },
];

export default recycleBinItems;
